var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateProfileStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77778 5.55556V0H47.2222V5.55556H2.77778ZM2.77778 44.4445V27.7778H0V22.2222L2.77778 8.33334H47.2222L50 22.2222V27.7778H47.2222V44.4445H41.6667V27.7778H30.5556V44.4445H2.77778ZM8.33333 38.8889H25V27.7778H8.33333V38.8889Z",
    fill: "#37BD6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfileStore);
export default __webpack_public_path__ + "static/media/UpdateProfileStore.970435bbaf3976a701ffbeb4a0697c8e.svg";
export { ForwardRef as ReactComponent };